import { VariableValue } from '@/core';
import { useCheckSplitGroup } from './split-mode-model';

export interface SplitOptionsState {
  isMainPanelGroup?: boolean;
  splitVariableName?: string;
  splitVariableValue?: VariableValue;
}

interface SplitModeOptionsProps {
  children: (splitOptions: SplitOptionsState) => React.ReactNode;
}

export function SplitModeOptions(props: SplitModeOptionsProps) {
  const { children } = props;
  const { isMainPanelGroup, splitVariableName, splitVariableValue } = useCheckSplitGroup();
  return (
    <>
      {children({
        isMainPanelGroup,
        splitVariableName,
        splitVariableValue,
      })}
    </>
  );
}
